import { Pipe, PipeTransform } from '@angular/core';

import { representanteSituacoes } from '../representante-situacao';

@Pipe({
    name: 'representanteSituacaoColor'
})
export class RepresentanteSituacaoColorPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = representanteSituacoes.findIndex(Situacao => Situacao.id === value);
        if (index > -1) {
            return representanteSituacoes[index].color;
        }
        return '';
    }
}
